/* eslint-disable @typescript-eslint/no-use-before-define */
export type SubjectManagementCreatePendingDelete =
  | { type: 'sectionTeachingTime'; sectionIndex: number; itemIndex: number }
  | { type: 'teacherDraft'; itemIndex: number }
  | { type: 'projectTeachingTime'; itemIndex: number }
  | { type: 'projectTeacher'; sectionIndex: number; itemIndex: number };

export interface SubjectManagementCreateDeleteContext {
  sectionCount: number;
  sectionTeachingTimeCounts: Partial<Record<number, number>>;
  submittedSections: Partial<Record<number, boolean>>;
  lockedSections?: Partial<Record<number, boolean>>;
  teacherDraftCount: number;
  projectTeachingTimeCount: number;
  projectTeacherCounts: Partial<Record<number, number>>;
  isProjectResearch: boolean;
  activeTeacherSectionIndex: number | null;
}

export function getPendingDeleteMessage(pendingDelete: SubjectManagementCreatePendingDelete | null): string {
  return pendingDelete?.type === 'teacherDraft' || pendingDelete?.type === 'projectTeacher'
    ? 'คุณต้องการลบผู้สอนนี้ใช่หรือไม่ ?'
    : 'คุณต้องการลบวันและเวลาสอนนี้ใช่หรือไม่ ?';
}

export function isPendingDeleteValid(
  pendingDelete: SubjectManagementCreatePendingDelete,
  context: SubjectManagementCreateDeleteContext
): boolean {
  switch (pendingDelete.type) {
    case 'sectionTeachingTime': {
      const teachingTimeCount = context.sectionTeachingTimeCounts[pendingDelete.sectionIndex] ?? 0;
      return isValidSectionIndex(pendingDelete.sectionIndex, context.sectionCount)
        && context.submittedSections[pendingDelete.sectionIndex] !== true
        && teachingTimeCount > 1
        && isRemovableAdditionalItem(pendingDelete.itemIndex, teachingTimeCount);
    }
    case 'teacherDraft':
      return isActiveEditableSection(context)
        && isValidItemIndex(pendingDelete.itemIndex, context.teacherDraftCount);
    case 'projectTeachingTime':
      return context.isProjectResearch
        && isActiveEditableSection(context)
        && context.projectTeachingTimeCount > 1
        && isRemovableAdditionalItem(pendingDelete.itemIndex, context.projectTeachingTimeCount);
    case 'projectTeacher': {
      const teacherCount = context.projectTeacherCounts[pendingDelete.sectionIndex] ?? 0;
      return context.isProjectResearch
        && isValidSectionIndex(pendingDelete.sectionIndex, context.sectionCount)
        && context.submittedSections[pendingDelete.sectionIndex] !== true
        && isValidItemIndex(pendingDelete.itemIndex, teacherCount);
    }
  }
}

function isActiveEditableSection(context: SubjectManagementCreateDeleteContext): boolean {
  const sectionIndex = context.activeTeacherSectionIndex;
  return sectionIndex != null
    && isValidSectionIndex(sectionIndex, context.sectionCount)
    && context.submittedSections[sectionIndex] !== true;
}

function isValidSectionIndex(sectionIndex: number, sectionCount: number): boolean {
  return Number.isInteger(sectionIndex) && sectionIndex >= 0 && sectionIndex < sectionCount;
}

function isValidItemIndex(itemIndex: number, itemCount: number): boolean {
  return Number.isInteger(itemIndex) && itemIndex >= 0 && itemIndex < itemCount;
}

function isRemovableAdditionalItem(itemIndex: number, itemCount: number): boolean {
  return itemIndex > 0 && isValidItemIndex(itemIndex, itemCount);
}
